import { hydrateQuestionData } from '@src/app-components/dynamic-form/hydrateQuestionData';
import { hydrateQuestionThreads } from '@src/app-components/dynamic-form/hydrateQuestionThreads';
import { hydrateSectionData } from '@src/app-components/dynamic-form/hydrateSectionData';
import { sectionsById } from './permitProcessGuideData.sections';
import { getParentObject, permitProcessGuideQuestionNameById } from './permitProcessGuideData.types';
import { permitProcessGuideQuestionsById } from './permitProcessGuideData.questions';

// Generate parent threads for each question
hydrateQuestionThreads({ questionsById: permitProcessGuideQuestionsById, getParentObject });

// Add question ids and names to each question and question lists - reduces duplicate config definitions
hydrateQuestionData({
  questionsById: permitProcessGuideQuestionsById,
  questionNamesById: permitProcessGuideQuestionNameById,
});

// Add section ids for each section - reduces duplicate config definitions
hydrateSectionData({ sectionsById });

export const permitProcessGuideForm = {
  formId: 1,
  formTitle: 'Permit Process Questionnaire',
  questionsById: permitProcessGuideQuestionsById,
  sections: [sectionsById[1]],
  isInformation: false,
};
